import { render, staticRenderFns } from "./FlvVideo.vue?vue&type=template&id=be5c21d8&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./FlvVideo.vue?vue&type=script&lang=js"
export * from "./FlvVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports